import React, {CSSProperties} from 'react'
import styled from 'styled-components'
import {Tag} from './library/tag/tag'

export const StyledFlag = styled.div`
  margin: -1px 0 -1px 5px;
  display: inline-block;
  font-weight: normal;
`

// Feature flagged because they are not ready for customer use
export const PreviewFlagMarker = ({
  className,
  style
}: {
  className?: string
  style?: CSSProperties
}) => (
  <StyledFlag className={className} style={style}>
    <Tag appearance="blue">Preview</Tag>
  </StyledFlag>
)

// Feature flagged because they cost extra
export const PremiumFlagMarker = ({className}: {className?: string}) => (
  <StyledFlag className={className}>
    <Tag appearance="green">Premium</Tag>
  </StyledFlag>
)

export const DeprecatedFlagMarker = ({className}: {className?: string}) => (
  <StyledFlag className={className}>
    <Tag appearance="red">Deprecated</Tag>
  </StyledFlag>
)

// New feature - not prod ready
export const BetaFlagMarker = ({
  className,
  style
}: {
  className?: string
  style?: CSSProperties
}) => (
  <StyledFlag className={className} style={style}>
    <Tag appearance="blue">Beta</Tag>
  </StyledFlag>
)

/** Still a work in progress */
export const AlphaFlagMarker = ({
  className,
  style
}: {
  className?: string
  style?: CSSProperties
}) => (
  <StyledFlag className={className} style={style}>
    <Tag appearance="orange">Alpha</Tag>
  </StyledFlag>
)
